// @flow strict
import { Button, Card, Col, Divider, message, Modal } from "antd";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { BiEditAlt } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { deleteExistingPlan, updatePopularPlans } from "../../../api/pricing";
import UpdatePricingPlan from "./UpdatePlan";

function AdminPlanCard({ plan, setPlans }) {
  const [openModal, setOpenModal] = useState(false);

  const handleMakePopular = async () => {
    try {
      const res = await updatePopularPlans({ plan_id: plan._id });
      const plans = res?.data?.plans;
      if (plans) {
        setPlans(plans);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleClickDelete = (e) => {
    Modal.confirm({
      title: 'Delete Pricing Plan',
      content: 'Are you sure you want to delete this pricing plan? This plan will be removed and become inactive in Stripe.',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: handleDeletePlan,
      okType: "danger"
    });
  };

  const handleDeletePlan = async () => {
    try {
      const res = await deleteExistingPlan(plan._id);
      const plans = res?.data?.plans;
      if (plans) {
        setPlans(plans);
        message.success(res?.data?.message);
      };
    } catch (error) {
      message.error(error?.message);
    }
  };

  return (
    <>
      <Col xs={24} md={12} xl={8}>
        <Card
          hoverable className={plan?.is_popular ? "pricing-card popular-card" : "pricing-card"}>
          <div className="">
            {
              plan?.is_popular ?
                <p className="popular-badge">Most Popular</p>
                :
                <Button
                  className="btn-popular"
                  onClick={handleMakePopular}
                >
                  Make Popular
                </Button>
            }
            <h3 className="pricing-title">{plan.name}</h3>
            <p className="pricing-desc">{plan.description}</p>
            <div className="pricing-items mt-2">
              <p className="pricing-item">
                <FaCheckCircle className="pricing-icon" />
                <span>{`${plan?.token} chat tokens per month.`}</span>
              </p>
              <p className="pricing-item">
                <FaCheckCircle className="pricing-icon" />
                <span>
                  <span>Access to using</span>
                  <span className="text-capitalize">
                    {`${plan?.chat_providers.map((provider, i) => " " + provider)}.`}
                  </span>
                </span>
              </p>
              <p className="pricing-item">
                <FaCheckCircle className="pricing-icon" />
                <span>
                  {`Max ${plan?.max_file} ${plan?.max_file > 1 ? "files" : "file"} upload per assistant.`}
                </span>
              </p>
              <p className="pricing-item">
                <FaCheckCircle className="pricing-icon" />
                <span> {`${plan?.user_count} users per organization.`}</span>
              </p>
              <p className="pricing-item">
                <FaCheckCircle className="pricing-icon" />
                <span> {`${plan?.assistant_limit} assistants per organization.`}</span>
              </p>
              <p className={plan?.advance_parameter ? "pricing-item" : "pricing-item muted"}>
                <FaCheckCircle className="pricing-icon" />
                <span> {`Access to advance parameter settings.`}</span>
              </p>
              <p className={plan?.customize_chat ? "pricing-item" : "pricing-item muted"}>
                <FaCheckCircle className="pricing-icon" />
                <span> {`Access to customize chat.`}</span>
              </p>
            </div>
          </div>


          <div className="pricing-bottom">
            <Divider />
            {
              plan?.price_amount === 0 ?
                <>
                  <p className="pricing-rate">
                    Free Forever
                  </p>
                  <p className="mt-0">No credit card rteequired</p>
                </>
                :
                <>
                  <p className="pricing-rate">
                    {`$${plan.price_amount}`}
                    <span>{`/${plan?.interval}`}</span>
                  </p>
                  <p className="mt-0">Billed monthly</p>
                </>
            }

            <div className="action-btns">
              <Button onClick={() => setOpenModal(true)} size="large">
                <BiEditAlt />
                <span>Update Plan</span>
              </Button>
              {/* <Button onClick={handleClickDelete} size="large" danger>
                <RiDeleteBin6Line />
                <span>Delete Plan</span>
              </Button> */}
            </div>
          </div>
        </Card>
      </Col>
      <Modal
        title="Update Pricing Plan"
        open={openModal}
        onCancel={() => setOpenModal(false)}
        footer={[]}
      >
        <UpdatePricingPlan
          setPlans={setPlans}
          setOpenModal={setOpenModal}
          plan={plan}
        />
      </Modal>
    </>
  );
};

export default AdminPlanCard;